import React from 'react';
import { ClipboardCheckIcon, HourglassIcon, ListOrderedIcon, NotebookPenIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { solutionBenefits } from '../../data/content';
const icons = [HourglassIcon, ListOrderedIcon, NotebookPenIcon, ClipboardCheckIcon];
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-171" data-mp="1ohpjuwb4dzaq">
      <div className="mx-auto max-w-5xl" data-id="element-172" data-mp="1thln2tbztmp8">
        <SectionHeading id="solution-heading" title={<>
              Meet Your <Accent data-id="element-174" data-mp="23d5eb2fm3x7n">Ready-to-Teach</Accent> Hair Extension System
            </>} body={<>
              <strong className="font-semibold text-brand-charcoal" data-id="element-175" data-mp="27dz7obbtq47x">Hair Extension Instructor Ready™</strong> brings
              together the teaching resources you need to organize professional hair extension training in one
              convenient digital collection.
            </>} data-id="element-173" data-mp="1ye2lcgcwphg1" />

        <ul className="mx-auto mt-14 grid max-w-4xl gap-x-12 gap-y-10 sm:grid-cols-2" role="list" data-id="element-176" data-mp="nzusokk4w1f">
          {solutionBenefits.map((benefit, index) => {
          const Icon = icons[index];
          return <li key={benefit.title} className="flex items-start gap-4" data-id="element-177" data-mp="3mzx4cte109td" data-mpi={index}>
                <span className="flex h-12 w-12 flex-none items-center justify-center rounded-full" style={{
              backgroundColor: benefit.tint
            }} data-id="element-178" data-mp="3i49hikn0nsr1">
                  <Icon className="h-5 w-5 text-brand-charcoal" strokeWidth={1.5} aria-hidden="true" data-id="element-179" data-mp="enj3biha69e9" />
                </span>
                <span data-id="element-180" data-mp="9p7v1c6mw6y5">
                  <span className="block font-display text-[1.25rem] font-bold leading-tight text-brand-charcoal" data-id="element-181" data-mp="4o1zl6lla5kx">
                    {benefit.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-182" data-mp="2ub9eekic0w9h">
                    {benefit.text}
                  </span>
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}